import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { Element, scroller } from "react-scroll";
import { useEffect } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Offerings from "./components/Offerings";
import Register from "./components/Register";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";
import AdminDashboard from "./components/AdminDashboard";
import Masterclass from "./components/Masterclass";
import "./App.scss";

function HomePage() {
  const location = useLocation();

  useEffect(() => {
    const scrollTo = location.state && location.state.scrollTo;
    if (scrollTo) {
      // Defer to ensure DOM & Elements are mounted
      setTimeout(() => {
        scroller.scrollTo(scrollTo, {
          smooth: true,
          duration: 500,
          offset: -80,
        });
      }, 0);
    }
  }, [location]);

  return (
    <div className="app">
      <a className="skip-link" href="#main">
        Vai al contenuto
      </a>
      <Navbar />
      <main id="main">
        <Element name="hero">
          <Hero />
        </Element>
        <Element name="offerings">
          <Offerings />
        </Element>
        <Element name="about">
          <About />
        </Element>
        <Element name="testimonials">
          <Testimonials />
        </Element>
        <Element name="register">
          <Register />
        </Element>
        <Element name="faq">
          <FAQ />
        </Element>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/admin" element={<AdminDashboard />} />
        <Route
          path="/masterclass"
          element={
            <div className="app">
              <a className="skip-link" href="#main">
                Vai al contenuto
              </a>
              <Navbar />
              <main id="main">
                <Masterclass />
              </main>
              <Footer />
            </div>
          }
        />
        <Route path="/" element={<HomePage />} />
      </Routes>
    </Router>
  );
}

export default App;
